import {Survey, SurveyBranch, SurveyTargetPageType} from 'core/SurveyModels'

export class SurveyBranchesService {
  constructor(private survey: Survey) {}

  addBranch(pageName: string, branch: SurveyBranch) {
    const page = this.survey.pages.find((p) => p.name === pageName)!
    if (!page.branches) {
      page.branches = []
    }
    page.branches.push(branch)
  }

  removeBranch(pageName: string, index: number) {
    this.survey.pages
      .find((p) => p.name === pageName)!
      .branches?.splice(index, 1)
  }

  getTargetPage(
    pageName: SurveyTargetPageType
  ): SurveyTargetPageType | undefined {
    const result =
      this.survey.pages
        .find((p) => p.name === pageName)
        ?.branches?.map((branch) => {
          if ((branch.conditions?.length ?? 0) > 0) {
            const conditionFulfilled =
              branch.conditions?.map((condition) => {
                const element = this.survey.pages
                  .find((p) => p.name === pageName)
                  ?.elements.find((el) => el.name === condition.elementName)
                if (typeof condition.value === 'object') {
                  const [a1, a2] = [condition.value, element?.value] as [
                    unknown[],
                    unknown[]
                  ]
                  return (
                    a1.length === a2.length &&
                    a1.every((v) => a2.indexOf(v) !== -1)
                  )
                } else {
                  return condition.value === element?.value
                }
              }) ?? []
            if (conditionFulfilled.length === 0) {
              return undefined
            }
            if (conditionFulfilled.length === 1) {
              return conditionFulfilled[0] ? branch.targetPage : undefined
            }
            const chainOperation =
              branch.conditions?.map((c) => c.conditionChain) ?? []
            let previousFulfilled = conditionFulfilled[0]
            for (let i = 1; i < conditionFulfilled.length; i++) {
              previousFulfilled =
                chainOperation[i] === 'or'
                  ? previousFulfilled || conditionFulfilled[i]
                  : previousFulfilled && conditionFulfilled[i]
            }
            if (!previousFulfilled) {
              return undefined
            }
          }
          return branch.targetPage
        })
        .filter((tp) => tp !== undefined) ?? []
    return result[0]
  }
}
